export default __webpack_public_path__ + "static/media/keyvisual-dusseldorf.41623411.jpg";